import React from 'react';
import { Image, Vector } from '../base/Elements';

export const Parallax = ({src}) => {
  switch (src) {
    case 'laptop':
      return <LaptopImage />

    case 'desktop':
      return <DesktopImage />

    case 'password':
      return <SecretImage />

    case 'phone':
      return <PhoneImage />

    case 'success':
      return <SuccessImage />

    case 'failure':
      return <FailureImage />

    case 'error':
      return <ErrorImage />
  }

  return (<span></span>);
}

const LaptopImage = () => (
  <div className="parallax__wrap" key="login">
    <Vector className="parallax__bg-color" src='signin/bg_color' alt="" />
    <Vector className="parallax__laptop" src="signin/bg" alt="" />
    <Vector className="parallax__bul" src="signin/bul" alt="" />
    <Vector className="parallax__circle" src="signin/circle" alt="" />
    <Vector className="parallax__disc" src="signin/disc" alt="" />
    <Vector className="parallax__zoom" src="signin/zoom" alt="" />
    <Vector className="parallax__gear-big" src="signin/gear" alt="" />
    <Vector className="parallax__gear" src="signin/gear" alt="" />
  </div>
)

const DesktopImage = ({isAgreementAccepted}) => (
  <div className="parallax__wrap" key="registration">
    <Vector className="parallax__bg-color" src="signup/ghost" alt="" />
    <Vector className="parallax__letter" src="signup/letter" alt="" />
    <Vector className="parallax__laptop" src="signup/bg" alt="" />
    <Vector className="parallax__bul-hor" src="signup/bul" alt="" />
    <Vector className="parallax__ruler" src="signup/ruler" alt="" />
    <Vector className={`parallax__pen ${isAgreementAccepted && 'animate'}`} src="signup/pen" alt="" />
    <Vector className="parallax__pencil" src="signup/pencil" alt="" />
  </div>
)

const SecretImage = () => (
  <div className="parallax__wrap" key="passRecovery">
    <Vector src="password" />
  </div>
)

const PhoneImage = () => (
  <div className="parallax__wrap" key="smsApprove">
    <Vector src="confirm_sms" alt="" />
  </div>
)

const SuccessImage = () => (
  <div style={{width: '440px', height: '330px'}}>
    <Vector src="email_happy" alt="" />
  </div>
)

const FailureImage = () => (
  <div className="parallax__wrap" key="smsApprove">
    <Vector src="email_sad" alt="" />
  </div>
)

const ErrorImage = () => (
  <Vector src="any_case_error" alt="" />
)
